import PropTypes from 'prop-types';
import {useEffect, useRef} from 'react';
import {createUseStyles} from 'react-jss';
import MediaQueries from '../../../v2/style-helper/MediaQueries';
import Spacing from '../../../v2/style-helper/Spacing';

const useStyles = createUseStyles({
  autocompleteResult: {
    margin: 0,
    padding: [Spacing.single, Spacing.double],
    cursor: 'default',
    background: props => props.active && '#f2f2f2',
    
    [MediaQueries.phone]: {
      padding: [Spacing.double],
    },
    
    '&:first-child': {
      marginTop: Spacing.single,
    },
    
    '&:last-child': {
      marginBottom: Spacing.single,
    },
    
    '&:hover': {
      background: '#f2f2f2',
      cursor: 'pointer',
    },
  },
});

function AutocompleteResult(props) {
  const classes = useStyles(props);
  const resultElement = useRef(null);
  
  useEffect(() => {
    if (props.active) {
      try {
        resultElement.current.scrollIntoView({block: 'nearest', inline: 'nearest'});
      } catch (e) {
        // this is here in case scrollIntoView fails on a particular browser
      }
    }
  }, [props.active]);
  
  return (
    <li
      className={classes.autocompleteResult}
      data-test={props.active ? 'AutocompleteResult--active' : 'AutocompleteResult'}
      role="option"
      id={`result-item-${props.index}`}
      onClick={props.onClick}
      aria-selected={props.active}
      ref={resultElement}
    >
      {props.children}
    </li>
  );
}

AutocompleteResult.propTypes = {
  index: PropTypes.number.isRequired,
  children: PropTypes.node.isRequired,
  active: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default AutocompleteResult;
